












import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModuleData,
  Material,
  SerialNumber
} from "@/types";
import { isItemRequired } from "@/utilities";

import SerialnumbersManager from "@/containers/serialnumbers-manager";

import Vue, { PropType, VueConstructor } from "vue";

export default Vue.extend({
  components: {
    SerialnumbersManager
  },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>
  },

  computed: {
    isRequired(): boolean {
      const documentData: DynamicDocumentItemData[] = [
        { field: this.item.field, value: undefined }
      ];
      return isItemRequired(this.item, documentData, this.moduleData);
    },

    inverters(): Material[] {
      return this.$store.state.materials.inverters.items;
    },

    patterns(): string[] {
      return this.inverters.flatMap(inverter => inverter.patterns || []);
    },

    numberOfInverters(): number {
      // return this.moduleData.numberOfPanels ?? 0;

      const initialAmount = this.moduleData.inverterConfiguration?.flatMap(item => item.amount);

      if (initialAmount?.length) {
        return initialAmount.reduce((a, b) => a + b);
      } else {
        return 0;
      }
    }
  },

  methods: {
    checkType() {
      if (this.moduleData.inverterSerialNumbers!.length > 1) {
        this.save();
        return;
      }

      const sn = this.moduleData.inverterSerialNumbers?.[0];

      if (!sn) {
        this.$set(this.moduleData, "inverterId", undefined);
        this.save();
        return;
      }

      const types: Material[] = this.$store.getters["materials/inverters/findItemsBySn"](
        sn.serialNumber
      );

      this.$set(this.moduleData, "inverterId", types[0]?.id);
      this.save();
    },

    save() {
      this.$emit("save:module");
      this.$emit("save:document");
    }
  }
});
